import { Pipe, PipeTransform } from '@angular/core';

import { Audit } from '@models/audit';

@Pipe({
  standalone: true,
  name: 'timelineItemDescription'
})
export class TimelineItemDescriptionPipe implements PipeTransform {
  transform(audit: Audit, info: 'fullName' | 'email' | null): string {
    if (!audit?.actor) {
      return '';
    }
    if (audit.actor.type === 'system') {
      return 'Système';
    } else {
      switch (info) {
        case 'email':
          return audit.actor.email;
        case 'fullName':
          return `${audit.actor.firstName} ${audit.actor.lastName}`;
        default:
          return `${audit.actor.firstName} ${audit.actor.lastName} - ${audit.actor.email}`;
      }
    }
  }
}
